import { ButtonContainer } from "../../../generic-sprites/Buttons"
import { Scale } from "../../../utils/Scale"
import { EveryCigPart1Audio } from "../EveryCigAssets"
import { EveryCigBodyPart, EveryCigSprite } from "../EveryCigTypes"
import { EveryCigBodyPartButton } from "./EveryCigBodyPartButton"

export class EveryCigBodyPartButtonContainer implements EveryCigSprite {
    buttons: Array<EveryCigBodyPartButton>

    constructor(private game: Phaser.Game, button: ButtonContainer, group: Phaser.Group) {
        this.buttons = [
            new EveryCigBodyPartButton(game, EveryCigBodyPart.BRAIN,
                button, this.enable, this.disable, this.fadeIn, this.fadeOut, group, Scale.x(0.384), Scale.y(0.031)),
            new EveryCigBodyPartButton(game, EveryCigBodyPart.EYE,
                button, this.enable, this.disable, this.fadeIn, this.fadeOut, group, Scale.x(0.384), Scale.y(0.136)),
            new EveryCigBodyPartButton(game, EveryCigBodyPart.HEART,
                button, this.enable, this.disable, this.fadeIn, this.fadeOut, group, Scale.x(0.443), Scale.y(0.263)),
            new EveryCigBodyPartButton(game, EveryCigBodyPart.LUNGS,
                button, this.enable, this.disable, this.fadeIn, this.fadeOut, group, Scale.x(0.443), Scale.y(0.377)),
        ]
    }

    fadeIn = () => this.buttons.forEach(button => button.fadeIn())

    fadeOut = () => this.buttons.forEach(button => button.fadeOut())

    disable = () => this.buttons.forEach(button => button.disableButton())

    enable = () => this.buttons.forEach(button => button.enableButton())

    setNewButton = (b: ButtonContainer) => this.buttons.forEach(button => button.setNewButton(b))

    introSequence = () => {
        const audio = this.game.add.audio(EveryCigPart1Audio.CLICK_BODY)
        audio.onPlay.add(() => {
            this.fadeIn()
            this.disable()
        })
        audio.onStop.add(this.enable)
        audio.play()
    }
}
